import React from 'react'
import CustomTooltip from '../../../CustomTooltip'

export type OverflowClickHandler = React.MouseEventHandler<HTMLElement>

interface InsightTooltipProps {
  count: number
  tooltipTitle: React.ReactNode
  onClick?: OverflowClickHandler
  children?: React.ReactNode
}

export const InsightTooltip: React.FC<InsightTooltipProps> = ({
  count,
  tooltipTitle,
  children,
  onClick
}) => {
  if (count <= 0) {
    return null
  }
  const disableTooltip = Boolean(onClick)

  return (
    <CustomTooltip
      title={tooltipTitle}
      disableHoverListener={disableTooltip}
    >
      {children ?? `+${count}`}
    </CustomTooltip>
  )
}
